import { Button, Col, Form, Modal, Row, Tooltip } from 'antd';
import React, { forwardRef, ReactElement, useEffect, useImperativeHandle, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  convertToISOStrings,
  customGTMEvent,
  documentUploadFlow,
  findAndRemoveDraft,
  getCurrentUtcTime,
  getIsPageNameCancel,
  getIsPageNameDetail, getIsPageNameEdit, getIsPageNameEditDischarge,
  getIsPageNameNewAdmission, getIsPageNameReconsider, getLettersFromPatientDetails, getValidUploadedFiles, isAvailable,
  isValidStayLength,
} from '../../../../modules/crm/inPatient/service/crmUtils';
import { RootState } from '../../../../store';
import {
  setAdmissionForm, setFormAction, setGoToNext, setIsMinimize,
  setIsShowingDoADoDEnhancementModal,
  setIsShowOtherMinimize,
  setIsSubmitClickedFromModal,
  setMaxSizeForFile, setModalSwitch, setSubmitWithoutDocsClicked, submitIr, submitSettlement, submitSettlementCourierTrack,
} from '../../../../store/actions/newAdmissionAction';
import { setIsCashlessSubmit, setIsDeleteModal } from '../../../../store/actions/claimDetailsAction';

import { DRAFT_CHANGE_STATUSES, GUTTOR_SPACE, TRACK_COURIER, VALIDATE_MESSAGES } from '../../../constants/commonConstants';
import SvgIcon from '../../hoc/SvgIcon';
import { ReactComponent as Minimize } from './../../../../assets/images/svg/i_minimize.svg';
import { ReactComponent as Close } from './../../../../assets/images/svg/i_close_red.svg';
import { NewAdmissionState } from '../../../../store/models/newAdmissionModel';
import {
  actions, BUDDHIMED_NAV_NEW_ADMISSION, DETAIL_NAV, draftSequence, DRAFT_KEYS, FORM_SUBMIT_EVENTS, NEW_ADMISSION_FORM_KEY,
  SUBMIT_ENBLED_PAYERS,
  customerDetail,
  BUDDHIMED_NAV_NEW_ADMISSION_HIS,
  BUDDHIMED_NAV_NEW_ADMISSION_NON_HIS,
  HIS_UPLOAD_STATUS,
  IR_STATUS_NAMES,
  NEW_UPLOAD_STATUS,
  HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW,
  QUERY_DRAFT_FLOW,
} from '../../../constants/crmConstants';
import './../fileUpload.less';
import withRouterForwardRef from '../../hoc/withRouterForwardRef';
import { get, isArray, isEmpty } from 'lodash';
import { base64UrlDecode, centeredNotification } from '../../../../utils/utility';
import { getModalNav, getTitle, hisGetTitle, nonHisGetTitle } from '../../../../utils/fileUploadUtils';
import { fetchSavedDraft, saveDraftData, updateDraftId, updateSaveDraftStatus } from '../../../../store/actions/savedDraftAction';
import moment from 'moment';
import ApplicationDetail from '../../../services/applicationDetail.service';
import useGetPasswordExpireNotification from '../../../hooks/useGetPasswordExpireNotification';
import { checkAndFormatMomentObject } from '../../../../utils/dateTimeUtils';
import { ReactComponent as HISMinimize } from './../../../../assets/images/svg/HIS_Cross_Icon.svg';
import { ReactComponent as HISFileMinimize } from './../../../../assets/images/svg/HIS_Flow_Download_Icon.svg';
import { HospitalState } from '../../../../store/models/hospitalModel';

const MinimizeIcon = SvgIcon(Minimize);
const HisMinimizeIcon = SvgIcon(HISMinimize);
const HISFileMinimizeIcon = SvgIcon(HISFileMinimize);

const BuddhiMedFileUploadModal = forwardRef((
  {
    match: { params }, location: { pathname }, form = {},
    onSuccessSubmit,
    admissionForm,
    completeStep,
    isReimbursementModule = false,
  }: any,
  ref: any,
): ReactElement | null => {
  const isEditPage = getIsPageNameEdit(pathname);
  const isEditDischargePage = getIsPageNameEditDischarge(pathname);
  const isEditReconsider = getIsPageNameReconsider(pathname);
  const isDetailPage = getIsPageNameDetail(pathname);
  const isCancelPage = getIsPageNameCancel(pathname);
  const editPage = isEditPage || isEditDischargePage || isEditReconsider;
  const appService = ApplicationDetail.instance;
  const isDocumentEnabledChecklist = ApplicationDetail.instance.getIsDocumentChecklistEnabled();
  const isHisSearchEnabled = ApplicationDetail?.instance?.getIsHISSearchEnabled();
  const isPreAuthNewDesignEnabled = ApplicationDetail?.instance?.getIsPreAuthNewDesignEnabled();
  const { isOnNotificationFlow } = useSelector(
    (state: RootState): any => state.util,
  ) || [];
  const {
    isMinimize,
    admissionFormVal,
    uploadedFiles,
    selectedBeneficiaryDetail,
    isManualSubmission,
    updatedMemberName: memberName,
    selectedPackage,
    selectedTab,
    modalFormValue,
    isComponentRendered,
    isFileUploadEnabledForce,
    settlementType,
    additionalAdmissionInfo,
    isDraftSelected,
    modalSwitchDisabled,
    showOtherMinimize,
    selectedDiscrepency,
    selectedFiles,
    showProbability,
    defaultTimeline,
    isShowingDoADoDEnhancementModal,
    percent,
    isNewBornCase,
    isDateApplied,
    selectedHISFiles,
    updatedVisibleLetters,
    classificationArray,
    selectedDraft,
    isSubmiClickedFromModal,
  } = useSelector((state: RootState): NewAdmissionState => state.newAdmission);
  const { settlementValue, isDraftBtnClicked } = useSelector((state: RootState): any =>
    state?.selectedInPatientDetail || {});
  const { claimDetails, isCashlessSubmit, claimDetails: {
    allowStatus = [], patientName = '', nextAllowStatus = [],
  } }: any = useSelector((state: RootState): any => state.admissionDetails);
  const { payer, formControlConfig } = useSelector((state: RootState): any => state.payerList);
  const { isHISClaim, selectedPatientDetail, hospitalSearchPatientDetails }: any =
    useSelector((state: RootState): HospitalState => state.hospital);
  const attachments = getLettersFromPatientDetails(selectedPatientDetail, hospitalSearchPatientDetails);
  const dispatch = useDispatch();
  const [current, setCurrent] = useState(0);
  const [minimizeCount, setMinimizeCount] = useState(0);
  const [fullName, setFullName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [isShowMessage, setIsShowMessage] = useState(false);
  const [buddhimedNav, setBuddhimedNav] = useState<any[]>([]);
  const [decodedActionName, setDecodedActionName] = useState('');
  const [isFormChanged, setIsFormChanged] = useState(false);
  const history = useHistory();
  const { claimDetail, actionName: encodedActionName } = params;
  const [clicked, setClicked] = useState(false);
  const payerConfigValues = Object.values(formControlConfig);

  const isMinValidationRequired = payerConfigValues?.filter(({ type }: any): boolean => type === 'minValidtaionRequired');
  const minClaimedAmountValidtaionObject = isMinValidationRequired[0];
  const minClaimedAmountRequired = minClaimedAmountValidtaionObject?.['minClaimedAmount'];
  useImperativeHandle(ref, (): any => ({ setFullName }));
  const getNotification = useGetPasswordExpireNotification();

  const gotoClaimDetail = (): void => history.push(`/claims/in-patient/detail/${claimDetail}`);
  const gotoInpatient = (): void => history.push(`/claims/in-patient/`);

  const parsedDraftData = selectedDraft?.rawDraft?.length > 0 ? JSON?.parse(selectedDraft?.rawDraft) : {};

  const isQueryType = QUERY_DRAFT_FLOW?.some((keyword: any): any => parsedDraftData?.draftKey?.includes(keyword));
  const isSettlementDraft = parsedDraftData?.draftKey === DRAFT_KEYS.settlement;

  const getActionName = (): string => {
    let actionName = '';
    if (encodedActionName) {
      actionName = base64UrlDecode(encodedActionName);
    }
    return actionName;
  };

  const getCurrentActionName = (): string => {
    const isSettlementAvailable = getActionName() === actions.CASHLESSSUMBIT && isAvailable(allowStatus, actions.CASHLESSSUMBIT);
    const isIRAvailable = isAvailable(allowStatus, actions.SUBMITINFO) || isAvailable(allowStatus, actions.ENHANCEMENTQUERYREPLIED)
      || isAvailable(allowStatus, actions.EASYDISCHARGEQUERYREPLIED)
      || isAvailable(allowStatus, actions.DISCHARGEQUERYREPLIED) || isAvailable(allowStatus, actions.CLAIMQUERYREPLIED);
    const isCancellable = getActionName() === actions.CANCEL && isAvailable(allowStatus, actions.CANCEL) && isCancelPage;
    return isCancellable ? actions.CANCEL : isSettlementAvailable
      ? actions.CASHLESSSUMBIT :
      (isIRAvailable ? (actions.SUBMITINFO || actions.ENHANCEMENTQUERYREPLIED || actions.DISCHARGEQUERYREPLIED
        || actions.CLAIMQUERYREPLIED || actions.EASYDISCHARGEQUERYREPLIED) : actions.ENHANCEMENT);
  };

  const getHasShowDraft = (): boolean => {
    const actionName = getCurrentActionName();
    return (actionName === actions.CASHLESSSUMBIT || actionName === actions.SUBMITINFO);
  };

  const triggerCancellationModal = (): any => {
    if (getCurrentActionName() === actions.CANCEL) {
      dispatch(setIsDeleteModal(true));
      return [];
    }
  };

  const documentFlow = documentUploadFlow(isPreAuthNewDesignEnabled, attachments, claimDetails);

  useEffect((): void => {
    if (!isEmpty(claimDetails)) {
      const actionName = getActionName();
      if (isNewBornCase) {
        setFullName(memberName);
      } else {
        setFullName(patientName);
      }

      const isSettlementAvailable = isAvailable(allowStatus, actions.CASHLESSSUMBIT);
      const isCancelAvailable = isAvailable(allowStatus, actions.CANCEL);
      if ((!isSettlementAvailable && actionName === actions.CASHLESSSUMBIT) || (actionName === actions.CANCEL && !isCancelAvailable)) {
        gotoClaimDetail();
        return;
      }

      const isIRAvailable = isAvailable(allowStatus, actions.SUBMITINFO) || isAvailable(allowStatus, actions.ENHANCEMENTQUERYREPLIED)
        || isAvailable(allowStatus, actions.DISCHARGEQUERYREPLIED)
        || isAvailable(allowStatus, actions.CLAIMQUERYREPLIED) || isAvailable(allowStatus, actions.EASYDISCHARGEQUERYREPLIED);
      const isFreeEditAvailable = isAvailable(allowStatus, actions.EDIT);
      const allModalNav = getModalNav({
        minimizeCount, isEditPage, isEditDischargePage, actionName, isIRAvailable,
        isFreeEditAvailable, isHisSearchEnabled, isPreAuthNewDesignEnabled, isHISClaim, claimDetails, selectedPatientDetail,
        hospitalSearchPatientDetails, isEditReconsider, documentFlow, triggerCancellationModal,
      });

      setDecodedActionName(actionName);
      setBuddhimedNav([...allModalNav]);
      setCurrent(0);
      if (typeof buddhimedNav[current]?.title === 'function') {
        dispatch(setModalSwitch(false));
      }
      dispatch(setIsCashlessSubmit(actionName === actions.CASHLESSSUMBIT ? true : false));
    } else if (isDraftSelected) {
      setBuddhimedNav([...getModalNav({
        isHisSearchEnabled, isPreAuthNewDesignEnabled, isHISClaim,
        claimDetails, selectedPatientDetail, hospitalSearchPatientDetails, documentFlow, triggerCancellationModal,
      })]);
    }
    getMaxFileSize();
  }, [claimDetails, minimizeCount, selectedPatientDetail, hospitalSearchPatientDetails]);

  useEffect((): void => {
    if (isManualSubmission || isFileUploadEnabledForce || (!isEmpty(selectedBeneficiaryDetail) || isNewBornCase)) {
      setFullName(memberName);
      setBuddhimedNav([
        ...(documentFlow === HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ?
          BUDDHIMED_NAV_NEW_ADMISSION_HIS :
          documentFlow === NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ? BUDDHIMED_NAV_NEW_ADMISSION_NON_HIS : BUDDHIMED_NAV_NEW_ADMISSION),
      ]);
    }
  }, [isManualSubmission, selectedBeneficiaryDetail, isFileUploadEnabledForce, isNewBornCase]);

  const parseAmount = (value: string | number | undefined): number => {
    if (typeof value === 'string' && value?.includes('₹')) {
      const numericValue = value?.replace?.(/[^\d.-]/g, '');
      return parseFloat(numericValue) || 0; // Convert to number or return 0 if invalid
    }
    return 0;
  };

  const calculateDynamicTotalAmount = (values: Record<string, any>): number => {
    return Object?.values(values)
      ?.filter((value: any): any => {
        return typeof value === 'string' && value?.includes('₹');
      })
      ?.reduce((acc: number, value: any): any => acc + parseAmount(value), 0);
  };

  useEffect((): any => {
    if (isMinValidationRequired && !isDetailPage && !isCancelPage) {
      const totalAmount = calculateDynamicTotalAmount(admissionForm?.getFieldsValue());

      if (totalAmount > minClaimedAmountRequired) {
        setClicked(false);
      }
    }
  }, [admissionForm?.getFieldsValue()]);

  useEffect((): any => {
    setTimeout((): any => {
      if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && claimDetails?.isQuery && selectedFiles?.length > 0) {
        setClicked(false);
        dispatch(setIsSubmitClickedFromModal(false));
        dispatch(setModalSwitch(false));
      }
    }, 20);

  }, [selectedFiles]);

  useEffect((): void => {
    if (uploadedFiles?.length) {
      setErrorMessage('');
    }
  }, [uploadedFiles]);

  // for showing member name in file upload modal
  useEffect((): any => {
    if (isPreAuthNewDesignEnabled) {
      if (memberName) {
        setFullName(memberName);
      } else {
        setFullName('');
      }
    }
  }, [memberName]);

  useEffect((): any => {
    setTimeout((): any => {
      if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow &&
        showProbability === 0 && selectedFiles?.length > 0) {
        setClicked(false);
        dispatch(setIsSubmitClickedFromModal(false));
        dispatch(setModalSwitch(false));
      }
    }, 10);
  }, [selectedFiles, uploadedFiles]);

  const newFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === NEW_UPLOAD_STATUS);
  const updateButtonDisabledState = (): any => {
    if (
      (selectedHISFiles?.length ?? 0) > 0 ||
      (newFileUploads?.length ?? 0) > 0 ||
      (selectedFiles?.length ?? 0) > 0 ||
      settlementType === TRACK_COURIER
    ) {
      dispatch(setModalSwitch(false));
      setClicked(false);
      dispatch(setIsSubmitClickedFromModal(false));
    } else {
      dispatch(setModalSwitch(true));
    }
  };

  useEffect((): any => {
    if (isPreAuthNewDesignEnabled && !(isHISClaim || claimDetails?.isHISClaim) && selectedFiles?.length > 0) {
      setClicked(false);
      dispatch(setIsSubmitClickedFromModal(false));
      dispatch(setModalSwitch(false));
    }
  }, [selectedFiles, uploadedFiles]);

  useEffect((): any => {
    if (uploadedFiles?.length && isPreAuthNewDesignEnabled) {
      updateButtonDisabledState();
    }
  }, [uploadedFiles, selectedHISFiles, selectedFiles, percent, isMinimize]);

  useEffect((): any => {
    if (isPreAuthNewDesignEnabled) {
      if (!isMinimize && getIsPageNameNewAdmission(pathname)) {
        completeStep('claimReviewed');
      }
      if (getIsPageNameNewAdmission(pathname) && uploadedFiles?.length) {
        completeStep('documentsAttached');
      }
    }
  }, [isMinimize]);

  const getMinFileCount = (): any => {
    const fileCountObject = JSON.parse(payer?.minFileCount || '{}');
    const nextStatus = nextAllowStatus[0] || 'NEWADMISSION';
    try {
      if (fileCountObject[nextStatus]) {
        return Number(fileCountObject[nextStatus]);
      } else {
        return 1;
      }
    } catch (e) {
      return 1;
    }
  };

  const getMaxFileCount = (): any => {
    const fileCountObject = JSON.parse(payer?.maxFileCount || '{}');
    const nextStatus = nextAllowStatus[0] || 'NEWADMISSION';
    try {
      if (fileCountObject[nextStatus]) {
        return Number(fileCountObject[nextStatus]);
      } else {
        return null;
      }
    } catch (e) {
      return null;
    }
  };

  // modal for showing unchecked options
  const showOtherModal = (): any => {
    dispatch(setIsShowOtherMinimize(false));
  };

  const handleGAEvents = (): void => {
    if (
      isDocumentEnabledChecklist &&
      payer?.showOtherBuddhimedFlow &&
      (!claimDetails?.nextAllowStatus ||
        !claimDetails?.nextAllowStatus?.length ||
        claimDetails?.nextAllowStatus?.[0] === 'DISCHARGE') &&
      selectedDiscrepency?.length === 0 &&
      showProbability !== 0
    ) {
      customGTMEvent({
        event: 'SUBMITTED_WITHOUT_ANY_CHECKBOX_SELECTION',
      });
      return;
    }
    const flowName: any = claimDetails?.nextAllowStatus?.[0];
    if (isDraftBtnClicked && nextButtonName === 'Submit') {
      customGTMEvent({
        event: 'DRAFT_CLAIM_SUMBITTED',
      });
      return;
    }
    if (!flowName) {
      customGTMEvent({
        event: 'WA_CLAIMS_DOCUMENT_UPLOAD',
        remarks: form?.getFieldValue(['fileUploadRemark']),
      });
    } else if (flowName === 'ENHANCEMENT' || flowName === 'DISCHARGE') {
      if (isShowingDoADoDEnhancementModal) {
        customGTMEvent({
          event: 'Enhance- Entered DOA and DOD',
          DOA: checkAndFormatMomentObject(form?.getFieldValue('dateOfAdmission')),
          DOD: checkAndFormatMomentObject(form?.getFieldValue('dateOfDischarge')),
          isDischargingToday: form?.getFieldValue('isDischargeCase')?.[0] ?? 'N/A',
        });
      } else {
        customGTMEvent({
          event: 'Enhance- Upload Documents',
          remarks: form?.getFieldValue(['fileUploadRemark']),
          flow: flowName,
        });
      }
      dispatch(setIsShowingDoADoDEnhancementModal(false));
    } else if (flowName === 'CASHLESSSUMBIT') {
      customGTMEvent({
        event: 'Submit Settlement Request',
        remarks: form?.getFieldValue(['fileUploadRemark']),
        flow: defaultTimeline?.['title'],
      });
    } else if (flowName === 'SUBMITINFO') {
      if (isOnNotificationFlow) {
        customGTMEvent({
          event: 'Notification: Submit Query Response',
          claimNo: claimDetails?.payerClaimNo ?? '',
          timestamp: claimDetails?.modifiedOn,
          date: claimDetails?.modifiedOn,
          claimStatus: claimDetails?.allowStatus?.[0]?.actionName ?? '',
        });
      } else {
        customGTMEvent({
          event: 'Submit Query Response',
          remarks: form?.getFieldValue(['fileUploadRemark']),
          flow: defaultTimeline?.['title'],
        });
      }
    }
  };

  const next = (): void => {
    handleGAEvents();
    dispatch(setIsShowOtherMinimize(true));
    if (!showOtherMinimize) {
      dispatch(setSubmitWithoutDocsClicked(true));
    }
    setIsShowMessage(true);
    if (isReimbursementModule) {
      onSuccess();
    } if (buddhimedNav[current] && buddhimedNav[current].customValidation) {
      buddhimedNav[current].customValidation({
        form,
        updateAdmissionForm,
        goNext,
        uploadedFiles,
        setErrorMessage,
        modalAction,
        onMinimize,
        gotoClaimDetail,
        onSubmitIr,
        onSubmitSettlement,
        onSubmitSettlementCourier,
        settlementType,
        settlementValue,
        minFileCount: getMinFileCount(),
        exactFileCount: payer?.exactFileCount,
        maxFileCount: getMaxFileCount(),
        isDateApplied,
        hospitalSearchPatientDetails,
      });
    }
  };

  const goNext = (): void => {
    if (current < buddhimedNav.length - 1) {
      setCurrent(current + 1);
    } else {
      modalAction(true);
      if (allowFormSubmit && nextButtonName === 'Submit') {
        if (!isReimbursementModule) {
          setClicked(true);
          dispatch(setIsSubmitClickedFromModal(true));
        }
        dispatch(setFormAction(FORM_SUBMIT_EVENTS.SUBMIT));

      }
    }
  };

  const updateAdmissionForm = ({ dateOfAdmission, dateOfDischarge }: any): void => {
    admissionFormVal[NEW_ADMISSION_FORM_KEY[1]] = {
      ...admissionFormVal[NEW_ADMISSION_FORM_KEY[1]],
      ...{ dateOfAdmission, dateOfDischarge },
      ...{ stayLength: [dateOfAdmission, dateOfDischarge] },
    };
    if (payer?.isOnMailPayer) {
      admissionFormVal[customerDetail] = {
        ...admissionFormVal[customerDetail],
        ...{ stayLength: claimDetails?.stayLength },
      };
    }
    dispatch(setAdmissionForm(admissionFormVal));
  };

  const prev = (): void => {
    setCurrent(current - 1);
  };

  const modalAction = (action: boolean): void => {
    dispatch(setIsMinimize(action));
  };

  const getMaxFileSize = (): any => {
    const fileCountObject = JSON.parse(payer?.allowedFileSizeInMB || '{}');
    const nextStatus = nextAllowStatus[0] || 'NEWADMISSION';
    try {
      if (fileCountObject[nextStatus]) {
        dispatch(setMaxSizeForFile(Number(fileCountObject[nextStatus])));
      } else {
        dispatch(setMaxSizeForFile(15));
      }
    } catch (e) {
      dispatch(setMaxSizeForFile(15));
    }
  };

  useEffect((): void => {
    getMaxFileSize();
    document.body.style.overflowY = isMinimize ? 'auto' : 'hidden';
  }, [isMinimize]);

  useEffect((): void => {
    if (isComponentRendered) {
      modalAction(false);
      const { dateOfAdmission, dateOfDischarge, dateOfDelivery, dispatchDate, dateOfDispatch, stayLength } = modalFormValue || {};
      if (dateOfAdmission) {
        modalFormValue.dateOfAdmission = moment(dateOfAdmission);
      }
      if (dateOfDischarge) {
        modalFormValue.dateOfDischarge = moment(dateOfDischarge);
      }
      if (isValidStayLength(stayLength)) {
        const stayLengthISO = convertToISOStrings(stayLength);
        modalFormValue.stayLength = stayLengthISO;
      }
      if (dateOfDelivery) {
        modalFormValue.dateOfDelivery = moment(dateOfDelivery);
      }
      if (dispatchDate) {
        modalFormValue.dispatchDate = moment(dispatchDate);
      }
      if (dateOfDispatch) {
        modalFormValue.dateOfDispatch = moment(dateOfDispatch);
      }
      form.setFieldsValue(modalFormValue);
      if (buddhimedNav.length && buddhimedNav.length > 1) {
        next();
      }
    }
  }, [isComponentRendered, modalFormValue]);

  const onMinimize = (): void => {
    const validFiles: any = getValidUploadedFiles(uploadedFiles);
    const stayLength = form.getFieldValue(['stayLength']);

    if (buddhimedNav?.length === 2 && (!stayLength || !validFiles?.length)) {
      gotoClaimDetail();
    } else if (minimizeCount === 0 && !isDetailPage) {
      dispatch(setGoToNext(true));
      setMinimizeCount(minimizeCount + 1);
    }
    modalAction(true);
    setIsShowMessage(false);
  };

  const onSuccess = (): void => {
    setClicked(false);
    dispatch(setIsSubmitClickedFromModal(false));
    setIsSubmitLoading(false);
    removeDraftList();
    onSuccessSubmit();
  };

  const removeDraftList = (): void => {
    if (getHasShowDraft()) {
      const localDraft = JSON.parse(localStorage.getItem('draftSaved') as any) || {};
      const list = localDraft[draftSequence[3].key] || [];
      const draftIndex = list.findIndex((ele: any): any =>
        ele.newFormValue.customerDetail.memberId === claimDetails.memberId);
      if (draftIndex >= 0) {
        list.splice(list.indexOf(draftIndex), 1);
      }
      dispatch(fetchSavedDraft({
        ...localDraft,
        [localDraft[draftSequence[3].key]]: list,
      }));
      localStorage.setItem('draftSaved', JSON.stringify(localDraft));
    }
  };

  const onError = (errorMsg: string): void => {
    setClicked(false);
    dispatch(setIsSubmitClickedFromModal(false));
    setIsSubmitLoading(false);
    if (errorMessage === 'PASSWORD_EXPIRED') {
      centeredNotification('Password expired', 'error', getNotification);
    } else {
      centeredNotification(errorMsg);
    }
  };

  const onSubmitIr = (): void => {
    setIsSubmitLoading(true);
    dispatch(submitIr(form, onSuccess, onError));
  };

  const onSubmitSettlement = (): void => {
    setClicked(true);
    dispatch(setIsSubmitClickedFromModal(true));
    setIsSubmitLoading(true);
    dispatch(submitSettlement(form, onSuccess, onError));
  };
  const onSubmitSettlementCourier = (): void => {
    setClicked(true);
    dispatch(setIsSubmitClickedFromModal(true));
    setIsSubmitLoading(true);
    dispatch(submitSettlementCourierTrack(form, onSuccess, onError));
  };

  const getStayLength = (): any => {
    const treatmentStayLength = admissionFormVal?.treatmentDetail?.stayLength;
    const customerStayLength = admissionFormVal?.customerDetail?.stayLength;

    return {
      selectedDates: treatmentStayLength || customerStayLength || [],
    };
  };

  const { selectedDates } = getStayLength();

  const saveDraft = async (): Promise<void> => {
    const { DRAFT_SAVED } = DRAFT_CHANGE_STATUSES;
    const actionName = getCurrentActionName();
    const memberId = get(claimDetails, 'memberId');
    // checking whether status id is present and allowstatus is SUBMITINFO for query flows
    const draftKey = (claimDetails?.statusId && actionName === actions.SUBMITINFO)
    ? IR_STATUS_NAMES[claimDetails?.statusId] // Use corresponding status name for IR
    : (actionName === actions.CASHLESSSUMBIT)
      ? DRAFT_KEYS.settlement
      : DRAFT_KEYS.enhance;

    let draftList = [];
    const localDraft = JSON.parse(localStorage.getItem('draftSaved') as any) || {};
    if (localDraft[draftKey]) {
      draftList = localDraft[draftKey];
    }

    draftList = findAndRemoveDraft(memberId, draftList);
    const newFormValue = {
      ...admissionFormVal,
      ...{
        [DETAIL_NAV()?.[selectedTab]?.formKey]: admissionForm.getFieldsValue(),
      },
    } as any;
    const formValue = {
      ...form.getFieldsValue(),
      dateOfAdmission: selectedDates?.[0],
      dateOfDischarge: selectedDates?.[1],
      stayLength: [selectedDates?.[0], selectedDates?.[1]],
    };
    if (selectedTab < 0) {
      newFormValue['customerDetail'] = admissionForm.getFieldsValue();
    }
    const dateOfAdmission = new Date(claimDetails?.doa);
    const dateOfDischarge = new Date(claimDetails?.dod);
    if (isCashlessSubmit) {
      newFormValue.treatmentDetail = {
        ...newFormValue.treatmentDetail,
        dateOfAdmission,
        dateOfDischarge,
        stayLength: [dateOfAdmission, dateOfDischarge],
      };
    }
    const panCardField = form?.getFieldValue('panNumber')?.toUpperCase();

    const storeObj: any = {
      draftKey,
      modalFormValue: isFormChanged ? formValue : {},
      newFormValue,
      uploadedFiles,
      payer,
      selectedBeneficiaryDetail,
      selectedPackage,
      claimDetails,
      panCardField,
      selectedFiles,
      selectedHISFiles,
      hospitalSearchPatientDetails,
      updatedVisibleLetters,
      classificationArray,
      additionalAdmissionInfo: {
        draftStartTime: additionalAdmissionInfo?.admissionStartTime || '',
        draftEndTime: getCurrentUtcTime(),
      },
    };
    draftList.push(storeObj);
    localDraft[draftKey] = draftList;
    dispatch(fetchSavedDraft(localDraft));
    const successHandler = (): void => {
      dispatch(updateDraftId(0));
      centeredNotification('Draft has saved successfully.', 'info');
      dispatch(updateSaveDraftStatus(DRAFT_SAVED));
    };

    const onErrorHandler = (errorMssg: string): void => {
      centeredNotification(errorMssg);
    };
    const draftData = isArray(localDraft?.settlement) ? localDraft?.settlement[0] :
      // checking for query, enhancementquery, dischargequery, claimquery
      //  from the draft key to send the draftkey in the request
      isArray(localDraft?.[draftKey]) ? localDraft?.[draftKey]?.[0] : localDraft;
    const courierStatus = draftData?.claimDetails?.courierStatus;
    if (isArray(courierStatus) && courierStatus.length === 0) {
      draftData.claimDetails.courierStatus = '';
    }
    dispatch(saveDraftData(draftData, successHandler, onErrorHandler));
  };

  const onClose = (): void => {
    modalAction(true);
    // when its draft of settlement and query routing it to inpatient page
    if (isDraftBtnClicked && (isSettlementDraft || isQueryType)) {
      gotoInpatient();
    } else {
      gotoClaimDetail();
    }
  };

  if (!buddhimedNav?.length) {
    return <React.Fragment />;
  }

  let isSubmitBlocked = false;
  if (appService.getIsBetaHospital() && !(SUBMIT_ENBLED_PAYERS?.includes(payer?.uniqueIdentifier))) {
    isSubmitBlocked = true;
  }
  const { component: ContentComponent, isShowDraft, dynamicNextButton, allowFormSubmit, skipButton }: any = buddhimedNav[current];
  let { nextButtonName } = buddhimedNav[current];
  let { title } = buddhimedNav[current];
  if (typeof title === 'function') {
    title = documentFlow === HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ? hisGetTitle(uploadedFiles) :
      documentFlow === NON_HIS_NEW_DESIGN_DOCUMENT_UPLOAD_FLOW ? nonHisGetTitle(uploadedFiles) :
        getTitle(uploadedFiles);
  }
  if (!isSubmitBlocked && !nextButtonName && dynamicNextButton) {
    nextButtonName = dynamicNextButton({
      selectedTab,
    });
  }
  if (isReimbursementModule) {
    nextButtonName = 'Submit';
  }
  const onSkipToNextTab = (): any => {
    if (current < buddhimedNav.length - 1) {
      setCurrent(current + 1);
    } else {
      dispatch(setGoToNext(true));
      setMinimizeCount(minimizeCount + 1);
      modalAction(true);
    }
  };
  const hisFileUploads = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === HIS_UPLOAD_STATUS);
  const newUploadedFiles = uploadedFiles?.filter((fileUid: any): any => fileUid?.claimStatus === 'New uploads');

  const disableBtn = uploadedFiles?.reduce((result: any, item: any): any => {
    if (item?.claimStatus === 'New uploads' || item?.claimStatus === HIS_UPLOAD_STATUS) {
      result = false;
    } else if (isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && claimDetails?.isQuery
      && selectedFiles?.length > 0) {
      result = false;
    } else {
      result = true;
    }
    return result;
  }, {});

  const getModalClassName = (): string => {
    if (!isPreAuthNewDesignEnabled || title === 'Update Details') {
      return 'open';
    }

    const isHisClaimActive = !isEmpty(attachments);
    const hasLetters = selectedPatientDetail?.letters?.length > 0 || hospitalSearchPatientDetails?.[0]?.letters?.length > 0;

    if (isHisClaimActive) {
      if (hasLetters) {
        if (getIsPageNameDetail(pathname)) {
          return 'His-open-new-detail';
        }
        if (disableBtn) {
          return 'His-open-new';
        }
        if (hisFileUploads?.length && newUploadedFiles?.length === 0) {
          return 'His-open-file-selection';
        }
        return 'His-open';
      }
      return 'Non-His-open';
    }

    return 'Non-His-open';
  };

  const getAnimationClass = (): any => {
    return isMinimize ? 'animate-bottom' : '';
  };

  return (
    <React.Fragment>
      <div className={!isMinimize ? 'back-drop' : ''} />
      <div
        data-testid="file-upload-modal"
        className={`minimize-modal-wrapper ${getModalClassName()} ${getAnimationClass()}`}
      >
        <div className={`${(isPreAuthNewDesignEnabled) ? 'modal-header-title border-transparent' : ''} modal-header`}>
          <h4 className={`${(documentFlow || isPreAuthNewDesignEnabled) ? 'upload-doc' : ''}`}>{`${title}${fullName ? ' for ' + fullName : ''}`}</h4>
          {
            !(actions.CASHLESSSUMBIT === getCurrentActionName() || actions.SUBMITINFO === getCurrentActionName() ||
              actions.ENHANCEMENTQUERYREPLIED === getCurrentActionName() || actions.DISCHARGEQUERYREPLIED === getCurrentActionName()
              || actions.CLAIMQUERYREPLIED === getCurrentActionName()) ?
              <Tooltip title="Minimize document window">
                <span
                  onClick={(): void => onMinimize()} className="minimize-btn" data-testid="minimize-icon">
                  {
                    isPreAuthNewDesignEnabled
                      ? (!isEmpty(attachments) &&
                        (getIsPageNameNewAdmission(pathname) || editPage))
                        ? <HISFileMinimizeIcon />
                        : (getIsPageNameNewAdmission(pathname) || editPage)
                          ? <HisMinimizeIcon />
                          : <MinimizeIcon />
                      : <MinimizeIcon />
                  }
                </span>
              </Tooltip> : <Tooltip title="Close document window">
                <span
                  onClick={onClose} className="close-btn" data-testid="minimize-icon">
                  <Close />
                </span>
              </Tooltip>
          }
        </div>
        {/* modal for showing unuploaded files */}
        {(isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && (!claimDetails?.nextAllowStatus ||
          !claimDetails?.nextAllowStatus?.length || claimDetails?.nextAllowStatus?.[0] === 'DISCHARGE') && !showOtherMinimize &&
          selectedDiscrepency?.length && showProbability !== 0) ? (
          <Modal
            visible={!showOtherMinimize}
            centered={true}
            closable={false}
            width={500}
            bodyStyle={{ height: '277px', overflowY: 'auto', marginTop: '-72px' }}
            footer={null}
          >
            <p className="missing-docs">Missing out a critical documents may increase queries</p>
            <div className="centered-container">
              <div className="docs-list">
                <p className="centered-text">You have not uploaded the following documents:</p>
              </div>
              <div className="unchecked-docs">
                <ul>
                  {selectedDiscrepency?.map((item: any, index: any): any => (
                    (item?.answer === 'no' || !item?.answer || item?.isSelectFile === false || !item?.isSelectFile) && (
                      <li key={index} className="list-items">
                        {item?.questionType}
                      </li>
                    )
                  ))}
                </ul>
              </div>
            </div>
            <div className={selectedDiscrepency?.length < 4 ? 'text-message-discrepency' : 'text-message'}>
              <p>Are you sure you want to proceed?</p>
            </div>

            <div className={selectedDiscrepency?.length < 4 ? 'modal-btn-doc-discrepency' : 'modal-btn-doc'}>
              <Row className="row-container-modal" gutter={16}>
                <Col>
                  <Button
                    id="document-cataract-goback"
                    type="primary"
                    onClick={(): any => dispatch(setIsShowOtherMinimize(true))}>
                    Go Back
                  </Button>
                </Col>
                <Col>
                  <Button id="cataract-submit-without-docs" type="ghost" className="ghost-primary-btn" onClick={next} style={{ fontWeight: 'bold' }}>
                    Submit without document(s)</Button>
                </Col>
              </Row>
            </div>
          </Modal>
        ) : null}

        <div className="modal-body crm-file-upload scrollbar">
          <Form
            layout="vertical"
            form={form}
            validateMessages={VALIDATE_MESSAGES}
            scrollToFirstError={true}
            onChange={(): void => setIsFormChanged(true)}
          >
            <>
              {
                ContentComponent ? <ContentComponent
                  form={form}
                  admissionForm={admissionForm}
                  actionName={decodedActionName}
                  setErrorMessage={setErrorMessage} /> : null
              }
            </>
            {
              isDetailPage ? null : <div className="steps-action">
                {isShowMessage ?
                  <div className={`error-text mr-10 d-inline-block ${isPreAuthNewDesignEnabled ?
                    'error-message error-text text-center error-text-bottom-12 error-message-centered' : ''}`}> {errorMessage}
                  </div> : <></>
                }
                <Row className="header-right-buttons" gutter={GUTTOR_SPACE}>

                  {current > 0 && minimizeCount === 0 && (
                    <Col className="prevbutton" md={4}>
                      <Button onClick={(): void => prev()} data-testid="prev">
                        Previous
                      </Button>
                    </Col>
                  )}

                  <Col md={current > 0 && minimizeCount === 0 ? 20 : 24} className={((isPreAuthNewDesignEnabled) &&
                    getIsPageNameNewAdmission(pathname))
                    ? 'text-center' : 'text-right'}>
                    {
                      getHasShowDraft() && isShowDraft && (isFormChanged || getValidUploadedFiles(uploadedFiles))
                        ?
                        <div className="button-draft">
                          <Button
                            type="ghost"
                            className="draft_text ghost-primary-btn"
                            onClick={saveDraft}
                            data-testid="save-draft-inbuddhimed-modal"
                            disabled={(clicked || modalSwitchDisabled || percent < 100)}
                          >
                            Save to draft
                          </Button>
                        </div>
                        : null
                    }
                    {
                      skipButton &&
                      <Button
                        className="mr-10"
                        onClick={onSkipToNextTab}
                      >
                        Skip
                      </Button>
                    }
                    <Button
                      className={
                        `${(!modalSwitchDisabled && percent === 100) ? 'btn-form-submit' : 'next-button'}`
                      }
                      type={nextButtonName !== 'Submit' ? 'primary' : undefined}
                      htmlType={nextButtonName === 'Submit' ? 'submit' : 'button'}
                      onClick={(isDocumentEnabledChecklist && payer?.showOtherBuddhimedFlow && (!claimDetails?.nextAllowStatus ||
                        !claimDetails?.nextAllowStatus?.length || claimDetails?.nextAllowStatus?.[0] === 'DISCHARGE') &&
                        selectedDiscrepency?.length && showProbability !== 0) ? showOtherModal : next}
                      disabled={buddhimedNav?.[current]?.title !== 'Update Details' ?
                        (isSubmiClickedFromModal || modalSwitchDisabled || percent < 100) : false}
                      loading={isSubmitLoading || isSubmiClickedFromModal}
                      data-testid="next"
                    >
                      {nextButtonName}
                    </Button>
                  </Col>
                </Row>
              </div>
            }
          </Form>
        </div>
      </div>
    </React.Fragment >
  );
});

export default withRouterForwardRef(BuddhiMedFileUploadModal);
